import React from 'react';
import { Col, Row, Segmented } from 'components';
import { TaskAttachments } from '../attachments';
import { useTaskDetails } from './useTaskDetails';
import { TaskGeneral } from '../general';
import { TaskLogs } from '../logs';

interface IEntityTaskDetails {
  entityName:
    | 'BRAND'
    | 'CLIENT'
    | 'ADMIN'
    | 'TASK'
    | 'SUPPLIER'
    | 'LEAD'
    | 'DEAL'
    | 'ITEM'
    | 'COUNTRY'
    | 'PURCHASE_REQUEST'
    | 'PURCHASE_ORDER';
  isFinalStatus?: boolean;
}

export const EntityTaskDetails = (props: IEntityTaskDetails) => {
  const { entityName, isFinalStatus } = props;
  const { onChange, tabOptions, activeTab } = useTaskDetails();

  return (
    <Row>
      <Col span={24}>
        <Segmented options={tabOptions} value={activeTab} onChange={onChange} style={{ marginBottom: 24 }} />
        {activeTab === 'General' && <TaskGeneral entity={entityName} isFinalStatus={isFinalStatus} />}
        {activeTab === 'Attachments' && <TaskAttachments isFinalStatus={isFinalStatus} />}
        {activeTab === 'Logs' && <TaskLogs />}
      </Col>
    </Row>
  );
};
